
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M5.00001 6H19C19.55 6 20 5.55 20 5C20 4.45 19.55 4 19 4H5.00001C4.45001 4 4.00001 4.45 4.00001 5C4.00001 5.55 4.45001 6 5.00001 6ZM20.16 7.8C20.07 7.34 19.66 7 19.18 7H4.82001C4.34001 7 3.93001 7.34 3.84001 7.8L2.84001 12.8C2.72001 13.42 3.19001 14 3.82001 14H4.00001V19C4.00001 19.55 4.45001 20 5.00001 20H13C13.55 20 14 19.55 14 19V14H18V19C18 19.55 18.45 20 19 20C19.55 20 20 19.55 20 19V14H20.18C20.81 14 21.28 13.42 21.16 12.8L20.16 7.8ZM12 18H6.00001V14H12V18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-store`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconStore

    ```js
    <b-new-b-icon-store />
    ```
</docs>


